// Lets code that clears the Apollo store outside the auth layer (the Xfinity inactive/resume
// flush) move the session signal, so consumers refetch the query clearStore() left errored.

export const SESSION_INVALIDATED_EVENT = 'crave:session-invalidated';

export const dispatchSessionInvalidated = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(SESSION_INVALIDATED_EVENT));
};
